import { render, staticRenderFns } from "./appdownload.vue?vue&type=template&id=1decc4a8&scoped=true&"
import script from "./appdownload.vue?vue&type=script&lang=js&"
export * from "./appdownload.vue?vue&type=script&lang=js&"
import style0 from "./appdownload.vue?vue&type=style&index=0&id=1decc4a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1decc4a8",
  null
  
)

export default component.exports